import React, { useEffect } from "react";
import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import { Link } from "react-router-dom";
import { getParameterFromURL, onlyNumbers } from "services/helper";
import { getGroupById } from "services/requests";

export default function SelectedGroups({
  selectedGroups,
  setSelectedGroups,
  isGroupSelected,
  onUncheck,
  setGroupDetails,
  setGroupPages
}) {
  useEffect(() => {
    const groupsIDs = getParameterFromURL("groups");
    if (groupsIDs) getGroups(groupsIDs);
  }, []);

  /**
   * @param {string} groupsIDs
   * It loads the groups that are passed in the URL. After loading them,
   * they're added to the selected groups
   */
  function getGroups(groupsIDs) {
    const IDs = groupsIDs
      ?.split(",")
      ?.filter((item) => onlyNumbers(item)?.length > 0);
    const promises = IDs?.map((id) => getGroupById(id));
    Promise.all(promises).then((groups) => {
      const validGroups = groups.filter((item) => item);
      setSelectedGroups(validGroups);
      const idsGroup = validGroups ? validGroups[0]?.id : null;
      setGroupDetails(idsGroup);
      const obj = {};
      ['cls', 'fcp', 'fid', 'lcp', 'inp', 'ttfb'].forEach(key => obj[key] = idsGroup);
      setGroupPages(obj)
    });
  }

  function unselectGroup(groupId) {
    const groupIndex = isGroupSelected(groupId, true);
    const foundIndex = groupIndex > -1;
    let updatedSelectedGroups = [...selectedGroups];

    if (foundIndex) {
      updatedSelectedGroups?.splice(groupIndex, 1);
      setSelectedGroups(updatedSelectedGroups);
      onUncheck && onUncheck(updatedSelectedGroups);
    }
  }

  if (selectedGroups?.length === 0) return null;
  return (
    <div className="selected-groups-container">
      {selectedGroups?.map((group) => {
        const { id, name } = { ...group };
        return (
          <Chip
            key={id}
            label={`${id} - ${name}`}
            color="info"
            className="chip-group"
            avatar={
              <Link key={id} to={`/url-group-details/${id}`}>
                <InfoIcon className="info-icon" />
              </Link>
            }
            onDelete={() => unselectGroup(id)}
            deleteIcon={<DeleteIcon className="delete-icon" />}
          />
        );
      })}
    </div>
  );
}
